<template>
  <b-card class="container-card">
    <b-row>
      <b-col
        v-for="column in DynamicUI.BI"
        :key="'card-bi-' + column.id"
        cols="12"
        :md="column.cols"
      >
        <b-row class="h-100">
          <b-col
            v-for="item in column.children"
            :key="'item-bi-' + item.id"
            cols="12"
            :md="item.cols"
          >
            <component
              :is="renderCardByType(item.type)"
              :configCard="item"
              :dataBi="DynamicUI.data"
              @fetchDynamicBi="fetchDynamicBi"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import { BCard, BRow, BCol } from 'bootstrap-vue';
  import vSelect from 'vue-select';
  import Ripple from 'vue-ripple-directive';
  import FilterCard from './bi-card/FilterCard.vue';
  import MultiOverallCard from './bi-card/MultiOverallCard.vue';
  import OverallCard from './bi-card/OverallCard.vue';
  import ChartCard from './bi-card/ChartCard.vue';

  import useBusinessIntelligence from '../hooks/useBusinessIntelligence';

  export default {
    directives: {
      Ripple,
    },
    components: {
      BCard,
      BRow,
      BCol,
      vSelect,
      FilterCard,
      MultiOverallCard,
      OverallCard,
      ChartCard,
    },
    setup() {
      const { DynamicUI, fetchDynamicBi } = useBusinessIntelligence();

      const renderCardByType = (type) => {
        switch (type) {
          case 'filter':
            return FilterCard;
          case 'overall':
            return OverallCard;
          case 'multi':
            return MultiOverallCard;
          case 'chart':
            return ChartCard;
          default:
            break;
        }
      };

      return {
        DynamicUI,
        renderCardByType,
        fetchDynamicBi,
      };
    },
  };
</script>

<style></style>
